export default "__VITE_ASSET__41ceb08b__"